import { MaestroAPI, maestroApiCall } from '@michelin/central-provider';
import hash from 'object-hash';
import { useQuery } from 'react-query';
import { apigatewayBaseRoute as baseURL } from 'services/restApiConst';
import { CountriesType, UFOPart } from 'types/UFOTypes';

interface GetPartParams {
  country_code: CountriesType;
  with_service_mspn: boolean;
  tire_size_id?: number;
  custom_tire?: boolean;
  mspn?: string;
  lump?: boolean;
}

const getTires: MaestroAPI = { method: 'GET', endpoint: 'tires', baseURL };

export function useGetTires(payload: GetPartParams | null) {
  return useQuery<UFOPart[] | null>(
    ['get-tire', hash(payload)],
    () => {
      if (payload) return maestroApiCall(getTires, payload);
      return null;
    },
    {
      cacheTime: 3600,
    },
  );
}
